import { render, staticRenderFns } from "./SellerDetails.vue?vue&type=template&id=a84006d0&"
import script from "./SellerDetails.vue?vue&type=script&lang=js&"
export * from "./SellerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports